<template>
  <div class="time-table">
    <div class="times-legende column">
      <div class="empty cell"></div>
      <div v-for="mode in modeEntries" :key="mode.key" class="time cell">
        <div class="color" :style="{ background: mode.color }"></div>
        {{ mode.label }}
      </div>
    </div>
    <div v-for="site in entries" :key="site.site" class="site-column column">
      <div class="site-name cell">{{ site.site }}</div>
      <div v-for="mode in modeEntries" :key="`${site.site}-${mode.key}`" class="site-time cell">
        {{ site[mode.key] }}
      </div>
    </div>
  </div>
</template>

<script>
import Computing from '@/components/Analysis/Computing';

export default {
  mixins: [Computing],

  props: {
    data: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      default: -1,
    },

    advencedMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modeEntries() {
      const extraRanges = this.data.useExtendedTimeRanges
        ? [
            { label: '+ 120 min', key: 'r120', color: '#611403' },
            { label: '61 - 120 min', key: 'r61120', color: '#d60808' },
          ]
        : [{ label: '+ 60 min', key: 'r60', color: '#d60808' }];

      return this.advencedMode
        ? [
            ...extraRanges,
            { label: '51 - 60 min', key: 'r5160', color: '#fa8231' },
            { label: '41 - 50 min', key: 'r4150', color: '#f5a623' },
            { label: '31 - 40 min', key: 'r3140', color: '#fed330' },
            { label: '21 - 30 min', key: 'r2130', color: '#20bf6b' },
            { label: '11 - 20 min', key: 'r1120', color: '#1daea1' },
            { label: '0 - 10 min', key: 'r010', color: '#2bcbba' },
          ]
        : [...extraRanges, { label: '31 - 60 min', key: 'r3160', color: '#f5a623' }, { label: '0 - 30 min', key: 'r030', color: '#1daea1' }];
    },

    entries() {
      let values = this.data.sites.map(e => {
        return {
          site: e.name,
          r010: e.details.collaboratorsByTimeRanges[0].count,
          r1120: e.details.collaboratorsByTimeRanges[1].count,
          r2130: e.details.collaboratorsByTimeRanges[2].count,
          r3140: e.details.collaboratorsByTimeRanges[3].count,
          r4150: e.details.collaboratorsByTimeRanges[4].count,
          r5160: e.details.collaboratorsByTimeRanges[5].count,

          r030: e.details.collaboratorsByTimeRanges[0].count + e.details.collaboratorsByTimeRanges[1].count + e.details.collaboratorsByTimeRanges[2].count,
          r3160: e.details.collaboratorsByTimeRanges[3].count + e.details.collaboratorsByTimeRanges[4].count + e.details.collaboratorsByTimeRanges[5].count,
          r60: e.details.collaboratorsByTimeRanges[6].count,

          r61120: e.details.collaboratorsByTimeRanges[6].count + e.details.collaboratorsByTimeRanges[7].count,
          r120: e.details.collaboratorsByTimeRanges[8].count,

          t45:
            e.details.collaboratorsByTimeRanges[0].count +
            e.details.collaboratorsByTimeRanges[1].count +
            e.details.collaboratorsByTimeRanges[2].count +
            e.details.collaboratorsByTimeRanges[3].count +
            (e.details.collaboratorsByTimeRanges[4].count * (e.details.collaboratorsByTimeRanges[4].averageTime - 40)) / 10,

          total:
            e.details.collaboratorsByTimeRanges[0].count +
            e.details.collaboratorsByTimeRanges[1].count +
            e.details.collaboratorsByTimeRanges[2].count +
            e.details.collaboratorsByTimeRanges[3].count +
            e.details.collaboratorsByTimeRanges[4].count +
            e.details.collaboratorsByTimeRanges[5].count +
            e.details.collaboratorsByTimeRanges[6].count +
            e.details.collaboratorsByTimeRanges[7].count +
            e.details.collaboratorsByTimeRanges[8].count,
        };
      });

      values.unshift({
        site: this.$t('actualSites', this.data.actualSites.length),
        r010: this.data.collaboratorsByTimeRanges[0].count,
        r1120: this.data.collaboratorsByTimeRanges[1].count,
        r2130: this.data.collaboratorsByTimeRanges[2].count,
        r3140: this.data.collaboratorsByTimeRanges[3].count,
        r4150: this.data.collaboratorsByTimeRanges[4].count,
        r5160: this.data.collaboratorsByTimeRanges[5].count,

        r030: this.data.collaboratorsByTimeRanges[0].count + this.data.collaboratorsByTimeRanges[1].count + this.data.collaboratorsByTimeRanges[2].count,
        r3160: this.data.collaboratorsByTimeRanges[3].count + this.data.collaboratorsByTimeRanges[4].count + this.data.collaboratorsByTimeRanges[5].count,
        r60: this.data.collaboratorsByTimeRanges[6].count,

        r61120: this.data.collaboratorsByTimeRanges[6].count + this.data.collaboratorsByTimeRanges[7].count,
        r120: this.data.collaboratorsByTimeRanges[8].count,

        t45:
          this.data.collaboratorsByTimeRanges[0].count +
          this.data.collaboratorsByTimeRanges[1].count +
          this.data.collaboratorsByTimeRanges[2].count +
          this.data.collaboratorsByTimeRanges[3].count +
          (this.data.collaboratorsByTimeRanges[4].count * (this.data.collaboratorsByTimeRanges[4].averageTime - 40)) / 10,

        total:
          this.data.collaboratorsByTimeRanges[0].count +
          this.data.collaboratorsByTimeRanges[1].count +
          this.data.collaboratorsByTimeRanges[2].count +
          this.data.collaboratorsByTimeRanges[3].count +
          this.data.collaboratorsByTimeRanges[4].count +
          this.data.collaboratorsByTimeRanges[5].count +
          this.data.collaboratorsByTimeRanges[6].count +
          this.data.collaboratorsByTimeRanges[7].count +
          this.data.collaboratorsByTimeRanges[8].count,
      });

      return values;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.time-table {
  display: flex;
  width: 100%;
  border-top: solid 1px colors.$clear-border-color;
  box-sizing: border-box;

  .column {
    width: 100%;
    border-right: solid 1px colors.$clear-border-color;

    &:last-child {
      border-right: none;
    }

    &.times-legende {
      width: 128px;
      flex-shrink: 0;

      .cell {
        position: relative;

        .color {
          position: absolute;
          $size: 16px;
          width: $size;
          height: $size;
          border-radius: 1px;
          left: 6px;
        }
      }
    }

    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      border-bottom: solid 1px colors.$clear-border-color;
      text-align: center;

      &.site-name {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>

<style lang="scss">
@use '@/styles/colors.scss';

.tv {
  .time-table {
    height: max-content;
    border: solid 1px colors.$clear-border-color;

    .column {
      height: auto;

      &.times-legende {
        width: 256px;

        .cell {
          .color {
            left: 32px;
          }
        }
      }

      .cell {
        height: 96px;
        font-size: 28px;

        &.site-name {
          font-size: 28px;
        }
      }
    }
  }
}
</style>
